function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 1064;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.gif$
// module id = 1064
// module chunks = 1